import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



export type Props = {
  class?: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    class: null
  },
  setup(__props: any) {

const props = __props as {
  class?: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`container`, props.class])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})